// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import BlogPostGrid from "../../../blog-list/BlogPostGrid";
import HomeBlogHeader from "./HomeBlogHeader";
import HomeBlogContainer from "./HomeBlogContainer";

import type { $BlogPosts } from "flow/types";

type Props = {
  posts: $BlogPosts,
};

const HomeBlogList = ({ posts }: Props) => {
  return (
    <HomeBlogContainer>
      <HomeBlogHeader />
      <BlogPostGrid posts={posts} />
    </HomeBlogContainer>
  );
};

export default withGlobalContext(HomeBlogList);
